import { ValuesAsKeys } from '@/types/common';

export type DocsLinks = ValuesAsKeys<typeof DocumentName, string>;

export enum ServerDocumentName {
	MfpPolicy = 'mfp_policy',
	TermOfUse = 'term_of_use',
	UserAgreement = 'user_agreement',
	PrivacyPolicy = 'privacy_policy',
	TermOfCookie = 'term_of_cookie',
	TechStack = 'tech_stack',
}

export const DocumentName = {
	[ServerDocumentName.MfpPolicy]: 'mfpPolicy',
	[ServerDocumentName.TermOfUse]: 'termOfUse',
	[ServerDocumentName.UserAgreement]: 'userAgreement',
	[ServerDocumentName.PrivacyPolicy]: 'privacyPolicy',
	[ServerDocumentName.TermOfCookie]: 'termOfCookie',
} as const;

export type DocData = {
	id: number;
	updated: Date | string;
	title: string;
	title_en: ServerDocumentName;
	file: string;
};
